import {useEffect, useState} from 'react';
import {translations} from '../../../i18n/translations';
import CollapsibleCheckbox from './collapsible-checkbox';
import {useTranslation} from 'react-i18next';
import {UserAvatar} from '../../../screens/private/office/professional-caregiver/planner/calendar/shared/user-avatar';
import {Stack} from '@mui/material';
import {useDailyCareLogFilters} from '../../../contexts/dailycare-log-filters/context';
import {filtersDrawerLoading} from '.';
import {AffiliatedUser} from '../../../backend/responses/affiliated-user';
import NestedCheckbox from '../../checkbox/nested-checkbox';

export const DailyCareLogUsersFilters = () => {
  const [expanded, setExpanded] = useState(false);
  const {t} = useTranslation();
  const {tasksFilters, users, toggleUserFilter, toggleAllUserFilters} = useDailyCareLogFilters();
  const [allUsers, setAllUsers] = useState(false);
  const [usersBySocialResponses, setUsersBySocialResponses] = useState<AffiliatedUser[]>();

  useEffect(() => {
    if (tasksFilters.users.length > 0) {
      setAllUsers(true);
    } else if (tasksFilters.users?.length === 0) {
      setAllUsers(false);
    }
  }, [tasksFilters.users, usersBySocialResponses]);

  useEffect(() => {
    if (users) {
      if (tasksFilters.socialResponseIds.length === 0) {
        setUsersBySocialResponses(users);
      } else {
        const usersBySocialResponses = users.filter((user) => {
          return user.affiliation.socialResponses?.some((socialResponse) =>
            tasksFilters.socialResponseIds.includes(socialResponse)
          );
        });
        setUsersBySocialResponses(usersBySocialResponses);
      }
    }
  }, [tasksFilters.socialResponseIds, users]);

  return (
    <CollapsibleCheckbox
      label={t(translations.office.professional_caregiver.settings.occurrences.patients)}
      expanded={expanded}
      checked={allUsers}
      onChange={(checked) => {
        toggleAllUserFilters(
          checked,
          checked && users
            ? users.filter((user) => user.user.id).map((user) => user.user.id || '')
            : []
        );
        setAllUsers(checked);
      }}
      toggleExpanded={setExpanded}
    >
      {!usersBySocialResponses
        ? filtersDrawerLoading()
        : usersBySocialResponses.map((user) => {
            return (
              <NestedCheckbox
                key={user.user.id}
                label={
                  <Stack flexDirection="row" gap={1}>
                    <UserAvatar
                      size="s"
                      name={user.user.name}
                      disableTooltip
                      picture={user.user.picture}
                      socialResponses={user.affiliation.socialResponses}
                    />
                    {user.user.name}
                  </Stack>
                }
                checked={user.user.id ? tasksFilters.users?.includes(user.user.id) : false}
                onChange={(selected) => {
                  if (user.user.id) {
                    toggleUserFilter(user.user.id, selected);
                  }
                }}
              />
            );
          })}
    </CollapsibleCheckbox>
  );
};
